// externals
import { connect } from 'react-redux';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';
import * as tradeInComponentActionCreators from '../../../store/actionCreators';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// consts/enums
import * as tradeInRoutes from '../../../utils/routes';
import { processStepperRoutes } from '../../../utils/tradeInDecisionLogic';
import {
    LOAN_BALANCE_OPTION_TYPES,
    STEPPER_ROUTES,
    LOAN_BALANCE_TRADE_IN_STEP,
    stepperRouteMap,
    LOAN_BALANCE_STEPS
} from '../../../utils/constants';
import { isShowroomExperience } from '../../../utils/configUtils';

// components
import RegistrationDetailsUI from './RegistrationDetailsUI';

// interfaces/types
import { IRegistrationDetailsUIStateProps, IRegistrationDetailsUIDispatchProps } from './RegistrationDetailsInterfaces';
import { IRootProps } from '../../../components/RootProps';
import { StepperRoute } from '../../../types';

export const mapStateToProps = (state: any, ownProps: IRootProps): IRegistrationDetailsUIStateProps => {
    const { tradeIn, tradeInState } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const isSalesView = isShowroomExperience(ownProps.config);
    const buyerRegisteredOwner = tradeInSelectors.isBuyerRegisteredOwner(tradeIn);
    const sellingVehicleRegisteredInSameState = tradeInSelectors.isSellingVehicleRegisteredInSameState(tradeIn);
    const isFetchingLienholders = tradeInSelectors.getTradeInIsLienholdersLoading(tradeInState);

    const tradeInSource = tradeIn?.source;
    const selectedStepperRoute: StepperRoute[] = stepperRouteMap[tradeInSource] || STEPPER_ROUTES.loanBalance;
    const stepperRoutes = processStepperRoutes(
        state,
        selectedStepperRoute,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled,
        ownProps.tradeIndex,
        LOAN_BALANCE_TRADE_IN_STEP,
        tradeInRoutes.TRADE_REGISTRATION_DETAILS
    );

    const pageTitle = 'Trade-In Vehicle';
    const pageSubTitle = 'Determine how much your current vehicle, is worth, and apply that value to your new vehicle.';

    return {
        buyerRegisteredOwner,
        sellingVehicleRegisteredInSameState,
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        isFetchingLienholders,
        urlPath: ownProps.tradeInRoute
    };
};

export const mapDispatchToProps = (dispatch: any): IRegistrationDetailsUIDispatchProps => {
    return {
        dispatchAnalytics: (type: string, description: string) => {
            dispatch(tradeInActionCreators.dispatchAnalytics(type, description));
        },
        goToRoute: (route?: string) => {
            const nextRoute = tradeInRoutes.TRADE_FIND_OPEN_LOAN;
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(nextRoute));
        },
        updateBuyerRegisteredOwner: (isBuyerRegisteredOwner: boolean) => {
            dispatch(tradeInActionCreators.updateBuyerRegisteredOwner(isBuyerRegisteredOwner));
        },
        updateSellingVehicleRegisteredInSameState: (isSellingVehicleRegisteredInSameState: boolean) => {
            dispatch(tradeInActionCreators.updateSellingVehicleRegisteredInSameState(isSellingVehicleRegisteredInSameState));
        },
        fetchLienholders: () => {
            dispatch(tradeInActionCreators.cdlFindOpenLoanBalanceButtonClicked());
            dispatch(tradeInActionCreators.fetchTradeInLienholders());
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_FIND_OPEN_LOAN));
        },
        onEstimateBalanceClick: () => {
            dispatch(tradeInActionCreators.cdlEstimateBalanceLinkClicked(LOAN_BALANCE_STEPS.REGISTRATION_DETAILS));
            dispatch(tradeInActionCreators.setLoanBalanceOption(LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE));
        },
        goBack: () => {
            dispatch(tradeInActionCreators.cdlBackButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_LOAN_BALANCE_OPTIONS));
        },
        removeTradeIn: () => {
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_IN));
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        cdlTradeInProgressStepperClicked: (analyticsId: string) => {
            dispatch(tradeInComponentActionCreators.cdlTradeInProgressStepperClicked(analyticsId));
        }
    };
};

const RegistrationDetails = connect(mapStateToProps, mapDispatchToProps)(RegistrationDetailsUI);

export default RegistrationDetails;
